import script from "./log-source.vue?vue&type=script&lang=ts&setup=true"
export * from "./log-source.vue?vue&type=script&lang=ts&setup=true"

import "./log-source.vue?vue&type=style&index=0&id=5c08ff4b&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\yang'ya'fei\\Documents\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c08ff4b"]])

export default __exports__